import React from 'react';
import LoadingSpinner, { LoadingSpinnerProps } from '../Spinner/LoadingSpinner';

type Props = {
    isLoading: boolean;
} & LoadingSpinnerProps;

export const LoadingComponent = ({
    isLoading = false,
    children,
    ...spinnerProps
}: React.PropsWithChildren<Props>) => {
    return <>{isLoading ? <LoadingSpinner {...spinnerProps} /> : children}</>;
};
